import Profile from "src/components/profile";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_customer/c/profile/")({
    component: Profile,
});
